import { SubscriptionPlanTitle } from '../../../../../../../../../shared/utils/subscription-plans';

export const customPlan = {
  id: 27,
  planName: SubscriptionPlanTitle.Custom,
  planCode: 'custom',
};

export const customBasePlanScaleMonthly = {
  id: 489,
  amount: '119.00',
  planName: SubscriptionPlanTitle.OutreachScaleMonthlyBase,
  planCode: 'email-outreach-scale-plus-monthly-04-2025',
  currency: 'USD',
  planValidityDays: 30,
  planType: 'value-based',
  planMode: 1,
  isCustomPlan: true,
  assignmentType: 'dynamic',
};

export const customBasePlanScaleQuarterly = {
  id: 490,
  amount: '321.00',
  planName: SubscriptionPlanTitle.OutreachScaleQuarterlyBase,
  planCode: 'email-outreach-scale-plus-quarterly-04-2025',
  currency: 'USD',
  planValidityDays: 90,
  planType: 'value-based',
  planMode: 3,
  isCustomPlan: true,
  assignmentType: 'dynamic',
};

export const customBasePlanScaleYearly = {
  id: 491,
  amount: '996.00',
  planName: SubscriptionPlanTitle.OutreachScaleYearlyBase,
  planCode: 'email-outreach-scale-plus-yearly-04-2025',
  currency: 'USD',
  planValidityDays: 365,
  planType: 'value-based',
  planMode: 12,
  isCustomPlan: true,
  assignmentType: 'dynamic',
};

const planIdsToDisplay = [480, 481, 482, 483, 484, 486, 487, 581, 582];

export const getOutreachPlanData = (planMode, allPlans) =>
  allPlans?.filter(
    (plan) =>
      plan?.planMode === planMode && planIdsToDisplay.includes(plan?.id),
  );

// We had changed the Email Outreach Pro and Scale plan IDs to 581 and 582.
// Due to this, they were being included in the custom plan, which triggered the dynamic API.
// We consider all plans with plan id >= to 489 as custom plans due to combinations of prospects and email count
// To avoid this, we added a condition to exclude the new IDs
export const getCustomScalePlusPlanData = (planMode, allPlans) =>
  allPlans?.filter(
    (plan) =>
      plan?.planMode === planMode &&
      plan?.id >= 489 &&
      ![581, 582].includes(plan?.id),
  );

export const isCustomScalePlusPlan = (planId) =>
  planId >= 489 && ![581, 582].includes(planId);
